import React from "react";
import ReactDOMServer from "react-dom/server";

function AccountStatementPDFFooterStatic(data) {
  const staticContent = (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <span style={{ fontWeight: "600", margin: "16px 0" }}>
        STATEMENT SUMMARY
      </span>

      <table
        style={{
          width: "100%",
          fontWeight: "600",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        <tbody>
          <tr>
            <td>No of transactions: {data?.meta?.numberOfTransactions}</td>
            <td>Dr Count: {data?.meta?.drCount}</td>
            <td>Cr Count: {data?.meta?.crCount}</td>
            <td>Debits: {data?.meta?.debits}</td>
            <td>Credits: {data?.meta?.credits}</td>
            <td>Closing Bal: {data?.meta?.closingBalance}</td>
          </tr>
        </tbody>
      </table>

      <table
        style={{
          width: "100%",
          fontWeight: "600",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        <tbody>
          <tr>
            <td>Generated On: {data?.meta?.generatedOn}</td>
            <td>Generated By: {data?.meta?.generatedBy}</td>
            <td>
              Total transaction amount: {data?.meta?.totalTransactionAmount}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ width: "100%", fontSize: "14px", marginTop: "24px" }}>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td style={{ width: "33%" }}>
              This is a computer generated statement and does not require
              signature.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default AccountStatementPDFFooterStatic;
